module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "indent1",
    attrs: {
      "id": "fm1"
    }
  }, [_c('em', [_vm._v("We divide time into years. We divide years into seasons. We have different names for every river, a different name for every ocean on the earth. But the river does not know that we have named it “river”—it does not know that it is separate from the waters that call “Come.” Come. The river has flowed a thousand years. It is spring, and the river is spilling with the newness of winter’s melted snow, each season flowing into each season. River, I have been gone a long time. I am returning to your waters. River, I’ve come back. River. I’m afraid. Carry me like water.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-742f120d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062045980_epub_fm1_r1.vue
// module id = 66
// module chunks = 0